import { gql } from '@apollo/client';

export const UPDATE_EMAIL = gql`
  mutation UpdateEmail($newEmail: String!, $currentPassword: String!) {
    updateEmail(input: { newEmail: $newEmail, currentPassword: $currentPassword }) {
      success
      errors
    }
  }
`;
